import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/hooks/useApi';
import type { SearchIdeasResponse } from '@/api/types';

/**
 * Example searches for outreachers, sourced from discovery's approved terms.
 *
 * Long stale time on purpose: the list changes when an admin approves a term,
 * which is a human-paced event, and this renders on a page outreachers keep
 * open all day.
 */
export function useSearchIdeas() {
  const api = useApi();
  return useQuery({
    queryKey: ['portal', 'search-ideas'],
    queryFn: () => api.get<SearchIdeasResponse>('/portal/search-ideas'),
    staleTime: 5 * 60_000,
  });
}
